import React, { ComponentProps } from 'react';
import MarkdownRenderer from 'markdown-to-jsx';
import Link from 'next/link';
import { H1, H2, H3, H4, H5, H6 } from '@/components/shadcn/typography';

interface MarkdownProps {
  children: string;
  options?: ComponentProps<typeof MarkdownRenderer>['options'];
  className?: string;
}

const Markdown = ({ options, ...props }: MarkdownProps) => {
  const { overrides, ...restOptions } = options || {};
  const defaultOverrides = {
    h1: {
      component: H1,
      props: {
        level: 1,
      },
    },
    h2: {
      component: H2,
      props: {
        level: 2,
      },
    },
    h3: {
      component: H3,
      props: {
        level: 3,
      },
    },
    h4: {
      component: H4,
      props: {
        level: 4,
      },
    },
    h5: {
      component: H5,
      props: {
        level: 5,
      },
    },
    h6: {
      component: H6,
      props: {
        level: 6,
      },
    },
    span: {
      props: {
        className: 'text-textPrimaryWhite',
      },
    },
    p: {
      props: {
        className: 'text-textPrimaryWhite font-light text-xs lg:text-sm',
      },
    },
    a: {
      component: ({
        href,
        children,
      }: {
        href: string;
        children: React.ReactNode;
      }) => {
        return (
          <Link href={href} className="text-xs font-light lg:text-sm">
            {children}
          </Link>
        );
      },
    },
    ul: {
      props: {
        className: 'list-disc list-inside',
      },
    },
    li: {
      props: {
        className: 'text-textPrimaryWhite text-xs lg:text-sm',
      },
    },
    ...overrides,
  };
  return (
    <MarkdownRenderer
      options={{
        overrides: defaultOverrides,
        forceBlock: true,
        ...restOptions,
      }}
      {...props}
    />
  );
};

export default Markdown;
